import Dialog from "@/components/Dialog";
import Button from "@/components/Button";
import classNames from "classnames";
import { StatusCounts } from "../types";

interface FinalizeScoresConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  loading?: boolean;
  scores: StatusCounts;
}

export default function FinalizeScoresConfirmationModal({
  open,
  onClose,
  onSave,
  loading = false,
  scores
}: FinalizeScoresConfirmationModalProps) {
  const {
    passingCount,
    qualifyingCount,
    failingCount,
    cheatingCount,
    excessiveCount,
    noCardCount,
    noShowCount,
    poorConductCount,
    weatherEventCount,
    withdrawalCount,
    excusedCount,
    medicalWithdrawalCount,
    disqualifiedCount
  } = scores;

  const suspensionCount =
    poorConductCount + cheatingCount + noCardCount + noShowCount + withdrawalCount + medicalWithdrawalCount;

  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline={`Finalize Scores`}
      actions={
        <>
          <Button variant="text" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={onSave}
            testId="finalize-confimation-button"
            disabled={loading}
            icon={loading ? "progress_activity" : undefined}
            iconClassName={classNames(loading && "animate-spin w-6 h-6 !block")}
          >
            Finalize Scores
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4" data-testid="finalize-confirmation">
        <div className="flex flex-col">
          {passingCount > 0 && <div className="text-label-large">Passing: {passingCount}</div>}
          {qualifyingCount > 0 && <div className="text-label-large">Qualifying: {qualifyingCount}</div>}
          {failingCount > 0 && <div className="text-label-large">Failing: {failingCount}</div>}
          {cheatingCount > 0 && <div className="text-label-large">Cheating: {cheatingCount}</div>}
          {excessiveCount > 0 && <div className="text-label-large">Excessive: {excessiveCount}</div>}
          {noCardCount > 0 && <div className="text-label-large">No Card: {noCardCount}</div>}
          {noShowCount > 0 && <div className="text-label-large">No Show: {noShowCount}</div>}
          {poorConductCount > 0 && <div className="text-label-large">Poor Conduct: {poorConductCount}</div>}
          {weatherEventCount > 0 && <div className="text-label-large">Weather Event: {weatherEventCount}</div>}
          {withdrawalCount > 0 && <div className="text-label-large">Withdrawal: {withdrawalCount}</div>}
          {medicalWithdrawalCount > 0 && (
            <div className="text-label-large">Medical Withdrawal: {medicalWithdrawalCount}</div>
          )}
          {excusedCount > 0 && <div className="text-label-large">Excused: {excusedCount}</div>}
          {disqualifiedCount > 0 && <div className="text-label-large">Disqualified: {disqualifiedCount}</div>}
        </div>

        <div>
          <div className="text-body-medium">
            <p>
              {"Are you sure you want to finalize these scores?"}
              {suspensionCount > 0 && (
                <>
                  {" "}
                  {suspensionCount} {suspensionCount === 1 ? "person" : "people"} will be suspended from taking the PAT
                  for 90 days.
                </>
              )}
              {excessiveCount > 0 && (
                <>
                  {" "}
                  {excessiveCount} {excessiveCount === 1 ? "person" : "people"} will be suspended from taking the PAT
                  indefinitely.
                </>
              )}
              {" Registrants will receive a notification of their verified result."}
            </p>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
